import { userMgmnt, parPage } from "../../config";
import {getQueryStringFrmObject, getApi, postApi,postFormApi } from "../helpers/utility";
class UserManagementApi {

  userLogin=async(userPojo)=>{
    if (userPojo) {
      // console.log("user pojo", JSON.stringify(userPojo));
      var result = await postApi(userMgmnt.userLogin, userPojo);
      return result;
    }
  }

  onboard = async (userPojo) => {
    // console.log("userpojo", userPojo);
    if (userPojo) {
      // console.log("user pojo", JSON.stringify(userPojo));
      var result = await postFormApi(userMgmnt.userOnboard, userPojo);
      return result;
    }
  };
  add = async (userPojo) => {
    // console.log("userpojo", userPojo);
    if (userPojo) {
      // console.log("user pojo", JSON.stringify(userPojo));
      var result = await postFormApi(userMgmnt.userAdd, userPojo);
      return result;
    }
  };
  update = async (userPojo) => {
    // console.log("userpojo" userPojo);
    if (userPojo) {
      // console.log("user pojo", JSON.stringify(userPojo));
      var result = await postFormApi(userMgmnt.userUpdate, userPojo);
      return result;
    }
  };
  list= async (readFilter, page) => {
    let finalListEndPoint;
    // console.log('readFilter',readFilter);
    finalListEndPoint = userMgmnt.userlist  + "?per_page=" + parPage+"&pageNo="+page;
    let searchParams = { info: readFilter };
     if (searchParams.info) {
      var queryString = getQueryStringFrmObject(searchParams);
      finalListEndPoint = finalListEndPoint + "&" + queryString;
    }
    var result = await getApi(finalListEndPoint);
    // console.log('result', result)
    return result;
  };
  investerList= async (readFilter, page) => {
    let parPage = 20;
    let finalListEndPoint;
    // console.log('readFilter',readFilter);
    finalListEndPoint = userMgmnt.investerList  + "?per_page=" + parPage+"&pageNo="+page;
    let searchParams = { info: readFilter };
     if (searchParams.info) {
      var queryString = getQueryStringFrmObject(searchParams);
      finalListEndPoint = finalListEndPoint + "&" + queryString;
    }
    var result = await getApi(finalListEndPoint);
    // console.log('result', result)
    return result;
  };
  findById = async (masterId) => {
    var result = await getApi(userMgmnt.findById, masterId);
    return result;
  };
  cddList= async (readFilter, page) => {
    let finalListEndPoint;
    // console.log('readFilter',readFilter);
    finalListEndPoint = userMgmnt.cddList  + "?per_page=" + parPage+"&pageNo="+page;
    let searchParams = { info: readFilter };
     if (searchParams.info) {
      var queryString = getQueryStringFrmObject(searchParams);
      finalListEndPoint = finalListEndPoint + "&" + queryString;
    }
    var result = await getApi(finalListEndPoint);
    // console.log('result', result)
    return result;
  };
  cdd_BulkUpdate_List = async (userPojo) => {
    // console.log("userPojo", userPojo);
    if (userPojo) {
      // console.log("trans pojo", JSON.stringify(userPojo));
      var result = await postApi(userMgmnt.cddBulk_Update, (userPojo));
      return result;
    }
  };
  compCddList= async (readFilter, page) => {
    let finalListEndPoint;
    // console.log('readFilter',readFilter);
    finalListEndPoint = userMgmnt.companyCddList  + "?per_page=" + parPage+"&pageNo="+page;
    let searchParams = { info: readFilter };
     if (searchParams.info) {
      var queryString = getQueryStringFrmObject(searchParams);
      finalListEndPoint = finalListEndPoint + "&" + queryString;
    }
    var result = await getApi(finalListEndPoint);
    // console.log('result', result)
    return result;
  };
   
}
export default new UserManagementApi();
